/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-15 21:20:35
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 12:39:12
 * @FilePath: /wemeet-web-activity/src/pages/questions/hooks/useQuestionList.ts
 * @Description: 问题列表hooks
 */
import { useEffect, useState, useMemo } from 'react';
import validateForm from "../utils/validateForm";
import RegisterTicketListQuestion from "../../quickServices/RegisterTicketListQuestion";
// import dataReport from '@utils/data-report';

const useQuestionList = (eId, tId, http, dataReport, userPhone) => {
  const [list, setList] = useState([]);
  const canSend = useMemo(() => validateForm(list, userPhone), [list, userPhone]);
  useEffect(() => {
    RegisterTicketListQuestion({
      event_id: eId,
      ticket_group_id: tId
    }, http).then(res => {
      if (res.code === 0) {
        const qList = res.data.question_list || [];
        setList(qList);

        // TODO: 来源需要区分活动助手
        dataReport('e#event_registration_form#all#exposure', {
          ticket_id: tId,
          questions_num: qList.length,
          the_source_path: 0
        });
      }
    });
  }, []);
  return {
    list,
    setList,
    canSend
  };
};
export default useQuestionList;